import React from 'react';
import { TestCatalogItem } from '@/hooks/use-test-catalog'; // Assuming type path
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ClipboardList } from 'lucide-react'; // Example icons

interface TestDetailCardProps {
  test: TestCatalogItem;
  onOrderClick: (testId: string) => void; // Handler for ordering
}

const TestDetailCard: React.FC<TestDetailCardProps> = ({ test, onOrderClick }) => {
  return (
    <Card className="flex flex-col justify-between h-full">
      <CardHeader>
        <CardTitle className="text-lg flex items-center">
           {/* <FileText className="h-5 w-5 mr-2 text-primary" /> */}{/* Optional Icon */} 
           {test.name}
        </CardTitle>
        {test.category && (
          <Badge variant="outline" className="w-fit">{test.category}</Badge>
        )}
      </CardHeader>
      <CardContent className="flex-grow">
        {test.description && (
          <p className="text-sm text-muted-foreground mb-2">{test.description}</p>
        )}
        {test.preparation && (
          <div>
            <h4 className="text-xs font-semibold text-muted-foreground uppercase mb-1">Preparation</h4>
            <p className="text-sm">{test.preparation}</p>
          </div>
        )}
      </CardContent>
      <CardFooter>
        {/* Conditionally render Order button? */} 
        <Button 
          size="sm" 
          className="w-full"
          onClick={() => onOrderClick(test.id)}
        >
          <ClipboardList className="mr-2 h-4 w-4" /> Order Test
        </Button>
      </CardFooter>
    </Card>
  );
};

export default TestDetailCard; 